// extracted by mini-css-extract-plugin
export var quantityInput = "_db-0";